<template>
   <Form ref="form" v-model="groupList" :label-width="parseInt(attrs.labelWidth)" v-if="isDisplay" label-position="right">
        <Row v-for="(item, index) in groupList.items" :key="item.__ob__.dep.id" style="line-height:32px;">
            <Col v-for="(child, k) in attrs.children" :key="child.__ob__.dep.id" :span="child.span">
                <FormItem style="margin:0;padding:5px 0;"
                    :label="attrs.labelWidth > 0 ? child.title : ''"
                    :prop="'items.' + index + '.' + child.field">
                    <ly-hoc :attrs="child" :page="page" :row="item" v-model="item[child.field]" ></ly-hoc>
                </FormItem>
            </Col> 
           <Col span="2" v-if="index != groupList.items.length && attrs.mode == 'edit'  && groupList.items.length > 1" align="center">
                <Button @click="handleRemove(index)" type="default" icon="ios-remove" shape="circle" size="small"></Button>
            </Col>
            <!-- <Col span="2" v-if="index == groupList.items.length-1 && attrs.mode == 'edit'" align="center"> -->
            <Col span="2" v-if="attrs.mode == 'edit'" align="center">
                <Button @click="handleAdd(index)" type="primary" icon="ios-add" size="small" shape="circle" ></Button>
            </Col>
            <Divider dashed style="border-width:2px;" v-if="index != groupList.items.length-1 && attrs.divider"/>
        </Row>        
    </Form>
</template>
<script>
/**
 *  下拉选择-数量-列表
 *  
 */
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    export default {
        name: 'LyRowGroup',
        mixins: [CompDisplayMixin],
        props: {
            value: {
                type: [Object, Array, String],
                default: []
            },
            attrs: {
                type: Object,
                default:_ => new Object()
            },
            page: {
                type: Object,
                default:_ => new Object()
            }
        },
        watch: {
            value: {
                handler () {
                    this.bindValue()
                },
                immediate: true
            }
        },
        data () {
            return {
                groupFields: {}, // 对应的字段
                groupList: {
                    items: [
                    ]
                },
                timer: 0
            }
        },
        created () {
            this.initField()
        },
        methods: {
            /**
             * 初始化绑定value
             */
            bindValue () {
                // 数组类型
                if (this.value instanceof String || this.value == '') { //初始化的时候 一定要保证回来的数据是数组
                    // this.value = []
                    this.imputEmit([])
                }
                if (this.value instanceof Array) {
                    if (this.value.length > 0 && this.value != this.groupList.items) {
                        this.groupList.items = this.value
                    } else { // 初始化数据为空 wxf 2020-09-08 
                        this.imputEmit(this.groupList.items)
                    }
                }
            },
            /**
             * 初始化对应的字段
             */
            initField () {
                this.attrs.children.forEach((el) => {
                    this.groupFields[el.field] = el.default || ''
                })
                // 初始化添加一个默认项目
                if (this.groupList.items.length < 1 && this.attrs.isDefault) {
                    this.handleAdd()
                }

            },
            /**
             * 添加一项
             */
            handleAdd (i = -1) {
                let item  = Object.assign({}, this.groupFields)
                // 指定索引后面添加
                this.groupList.items.splice(i + 1, 0, item)
                this.imputEmit(this.groupList.items)
            },
            /**
             * 删除一项
             */
            handleRemove (i) {
                this.groupList.items.splice(i, 1)
                this.imputEmit(this.groupList.items)
            },
            imputEmit (val) {
                let now = new Date().getTime()
                console.log(now - this.timer)
                // if (now - this.timer > 10) {
                    this.timer = new Date().getTime()
                    this.$emit('input', val)
                // }
            }
        }
    }
</script>
<style scoped>
.ivu-form-item-content {
    margin-left: 100px!important;
}
    
</style>


// WEBPACK FOOTER //
// ../projectCore/src/components/row-group/src/index.vue